import React from 'react';
import classNameBind from 'classnames/bind';

import styles from './RadioWidget.module.css';
import { RadioIcon } from '../RadioIcon';

const bindClasses = classNameBind.bind(styles);

const RadioWidget = ({
  name,
  id,
  value,
  selected,
  disabled,
  onClick,
  onBlur,
  dataId,
}) => (
  <label htmlFor={id} className={bindClasses('widget', { disabled })}>
    <RadioIcon disabled={disabled} selected={selected} />
    <input
      className={bindClasses('input', { disabled })}
      type="radio"
      name={name}
      id={id}
      value={value}
      disabled={disabled}
      onClick={onClick}
      onBlur={onBlur}
      data-ppuc-id={`${dataId}.input`}
    />
  </label>
);

export { RadioWidget };
